<mat-dialog-content class="cosmos-user-details__modal">
  <div class="cosmos-user-details__modal__close-button-wrapper">
    <button
      (click)="closeDetails()"
      class="cosmos-user-details__modal__close-button-wrapper__button"
    >
      <mat-icon>
        <span>close</span>
      </mat-icon>
    </button>
  </div>
  <cosmos-user-summary></cosmos-user-summary>
  <cosmos-user-clusters></cosmos-user-clusters>
  <cosmos-user-elements></cosmos-user-elements>
</mat-dialog-content>
